module.exports = function ($location, settings) {
    return {
        restrict: 'A',
        require: 'olyDynamicContent',
        link(scope, element, attrs, olyDynamicContent) {
            function getScheduleKey(panel) {
                const path = $location.path();
                const key = settings.dynamicContent.defaultScheduleKey;
                if (path) {
                    return path + (panel
                        ? `-${panel}${key}`
                        : `${key}`);
                }

                return null;
            }

            function updateScheduleKey() {
                olyDynamicContent.scheduleKey(getScheduleKey(attrs.olyDcUrlSchedule));
            }

            updateScheduleKey();

            scope.$on('$locationChangeSuccess', updateScheduleKey.bind(this));
        },
    };
};



// WEBPACK FOOTER //
// ./src/common/dynamiccontent/dynamic-content-url-schedule.js